const UsoDeCfdiCatalog = [
  {
    "clave": "G01",
    "descripcion": "Adquisición de mercancías",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "G02",
    "descripcion": "Devoluciones, descuentos o bonificaciones",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "G03",
    "descripcion": "Gastos en general",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "I01",
    "descripcion": "Construcciones",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "I02",
    "descripcion": "Mobiliario y equipo de oficina por inversiones",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "I03",
    "descripcion": "Equipo de transporte",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "I04",
    "descripcion": "Equipo de computo y accesorios",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "I05",
    "descripcion": "Dados, troqueles, moldes, matrices y herramental",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "I06",
    "descripcion": "Comunicaciones telefónicas",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "I07",
    "descripcion": "Comunicaciones satelitales",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "I08",
    "descripcion": "Otra maquinaria y equipo",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "D01",
    "descripcion": "Honorarios médicos, dentales y gastos hospitalarios.",
    "fisica": "Sí",
    "moral": "No",
    "regimen": "605, 606, 608, 611, 612, 614, 607, 615, 625",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "D02",
    "descripcion": "Gastos médicos por incapacidad o discapacidad",
    "fisica": "Sí",
    "moral": "No",
    "regimen": "605, 606, 608, 611, 612, 614, 607, 615, 625",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "D03",
    "descripcion": "Gastos funerales.",
    "fisica": "Sí",
    "moral": "No",
    "regimen": "605, 606, 608, 611, 612, 614, 607, 615, 625",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "D04",
    "descripcion": "Donativos.",
    "fisica": "Sí",
    "moral": "No",
    "regimen": "605, 606, 608, 611, 612, 614, 607, 615, 625",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "D05",
    "descripcion": "Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación).",
    "fisica": "Sí",
    "moral": "No",
    "regimen": "605, 606, 608, 611, 612, 614, 607, 615, 625",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "D06",
    "descripcion": "Aportaciones voluntarias al SAR.",
    "fisica": "Sí",
    "moral": "No",
    "regimen": "605, 606, 608, 611, 612, 614, 607, 615, 625",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "D07",
    "descripcion": "Primas por seguros de gastos médicos.",
    "fisica": "Sí",
    "moral": "No",
    "regimen": "605, 606, 608, 611, 612, 614, 607, 615, 625",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "D08",
    "descripcion": "Gastos de transportación escolar obligatoria.",
    "fisica": "Sí",
    "moral": "No",
    "regimen": "605, 606, 608, 611, 612, 614, 607, 615, 625",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "D09",
    "descripcion": "Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.",
    "fisica": "Sí",
    "moral": "No",
    "regimen": "605, 606, 608, 611, 612, 614, 607, 615, 625",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "D10",
    "descripcion": "Pagos por servicios educativos (colegiaturas)",
    "fisica": "Sí",
    "moral": "No",
    "regimen": "605, 606, 608, 611, 612, 614, 607, 615, 625",
    "inicio_de_vigencia": "2017-01-01",
    "fin_de_vigencia": null
  },
  {
    "clave": "P01",
    "descripcion": "Por definir",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "",
    "inicio_de_vigencia": "2017-03-31",
    "fin_de_vigencia": "2022-06-30"
  },
  {
    "clave": "S01",
    "descripcion": "Sin efectos fiscales.",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "601, 603, 605, 606, 608, 610, 611, 612, 614, 616, 620, 621, 622, 623, 624, 607, 615, 625, 626",
    "inicio_de_vigencia": "2022-01-01",
    "fin_de_vigencia": ""
  },
  {
    "clave": "CP01",
    "descripcion": "Pagos",
    "fisica": "Sí",
    "moral": "Sí",
    "regimen": "601, 603, 605, 606, 608, 610, 611, 612, 614, 616, 620, 621, 622, 623, 624, 607, 615, 625, 626",
    "inicio_de_vigencia": "2022-01-01",
    "fin_de_vigencia": ""
  },
  {
    "clave": "CN01",
    "descripcion": "Nómina",
    "fisica": "Sí",
    "moral": "No",
    "regimen": "605",
    "inicio_de_vigencia": "2022-01-01",
    "fin_de_vigencia": ""
  }
];

export {
  UsoDeCfdiCatalog
};